export default "__VITE_ASSET__B1e7lyHA__"